import { fromJS } from 'immutable';
import { SET_COLLECTION } from '../actionTypes';
import { CollectionRecord } from '../../records/collection';

const initialState = CollectionRecord({});

export default function collectionReducer(state = initialState, action) {
  switch (action.type) {
    case SET_COLLECTION: {
      const { payload } = action;
      return CollectionRecord(fromJS(payload));
    }

    default:
      return state;
  }
}
